import React, { useEffect, useState } from 'react';
import Layout from '../Components/Layout/Layout';
import DashIco1 from "../Components/Images/dash-top-1.svg";
import DashIco2 from "../Components/Images/dash-top-2.svg";
import DashIco3 from "../Components/Images/dash-top-3.svg";
import DashIco4 from "../Components/Images/dash-top-4.svg";
import DashIco5 from "../Components/Images/dash-top-5.svg";
import DashIco6 from "../Components/Images/dash-top-6.svg";
import AddIco from "../Components/Images/plus-add-ico.svg";
import Datatable from '../Components/Datatable/Datatable';
import { Link } from 'react-router-dom';
import { GetApiWithoutToken, PostApi, PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import Loader from '../Components/Layout/Loader';

export default function Advertisements() {

    const [advList, setAdvList] = useState([]);
    const [loader, set_loader] = useState(false);

    const columnList = ["name", "status", "type", "location", "view", "url"]

    useEffect(() => {
        set_loader(true);
        getAdvList();
    }, [])

    // const getStats = () => {
    //     const FeaturedAdvData = Promise.resolve(GetApiWithoutToken(API_PATH.GetStats));
    //     FeaturedAdvData.then(response => {
    //         if(response.status === 200) setStats(response?.data?.data ?? {});
    //         else setStats({});
    //     })
    // }

    const getAdvList = () => {
        const query = {
            "page": 1,
            "sizePerPage": 50
        }
        const FeaturedAdvData = Promise.resolve(PostApi(API_PATH.GetAdvByUser, query));
        FeaturedAdvData.then(response => {
            if(response.status === 200) format_data(response.data?.data?.advs ?? []);
            else setAdvList([]);
            set_loader(false);
        })
    }

    const format_data = (data) => {
        if(data.length > 0) {
            let formated_data = [];
            data.forEach(item => {
                let formated_item = {
                    "id": item._id ?? "-",
                    "name": item.name ?? "-",
                    "status": item.status === 1 ? "Active" : "Inactive",
                    "type": item.locale_brand === "B" ? "Branded" : "Locale",
                    "location": `${item.City ?? "-"}, ${item.State ?? "-"}`,
                    "view": item.view ?? 0,
                    "url": (item.url !== null && item.url !== undefined) ? <Link to={item.url} target="_blank" className='text-decoration-underline'>{item.url}</Link> : "-"
                }
                formated_data.push(formated_item);
            })
            setAdvList(formated_data);
        } else setAdvList([]);
    }
 

    return (
        <Layout>
            {loader === true ? <Loader></Loader> : <></>}
            <div className="nav-top-section">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-12 mt-3">
                            <div className="bx-white-main">
                                <div className="d-flex align-items-center">
                                    <h2 className="mb-0">Advertisements</h2>
                                    <div className="ms-auto">
                                        <Link to="/add-advertise" className="btn-all-comn d-flex justify-content-center align-items-center">
                                            <img src={AddIco} className="me-2" loading="lazy" alt="" />
                                            Add New Advertisement
                                        </Link>
                                    </div>
                                </div>
                                <div className="pt-2 mt-1">
                                    <Datatable column={columnList} data={advList} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}